import { useEffect, useRef } from 'react';

export type PropertyWatcherProps<T> = {
  value: T;
  onChange?: () => void | Promise<void>;
};

export function PropertyWatcher<T>({ value, onChange }: PropertyWatcherProps<T>) {
  const previousRef = useRef<{ initialized: boolean; value: T | undefined }>({
    initialized: false,
    value: undefined,
  });

  useEffect(() => {
    if (!previousRef.current.initialized || !Object.is(previousRef.current.value, value)) {
      previousRef.current = { initialized: true, value };
      void onChange?.();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return null;
}
